<template>
  <div>
    <div v-if="merchant.logo" class="pb-2">
      <v-img contain max-height="50px" min-height="50px" max-width="200px" min-width="200px" position="left center" :src="imageUrl + '/' + merchant.logo"/>
    </div>
    <div class="py-1">
      <v-btn
        small
        outline
        color="primary"
        :loading="loading"
        :disabled="loading"
        @click="$refs.logoInput.click()"
      >
        <v-icon small left>fa-upload</v-icon>
        {{ merchant.logo ? 'Update' : 'Add' }} Merchant Logo
      </v-btn>
      <v-btn
        v-if="merchant.logo"
        small
        outline
        color="error"
        class="ml-2"
        :loading="loading"
        :disabled="loading"
        @click="removeLogo"
      >
        <v-icon small left>fa-trash</v-icon>
        Remove Merchant Logo
      </v-btn>
      <input ref="logoInput" type="file" accept="image/*" @change="addFile" :disabled="loading" style="display: none">
    </div>
  </div>
</template>

<script>
import ApiMixin from '@/mixins/api'

export default {
  mixins: [ApiMixin],
  props: {
    merchant: Object
  },
  data: function () {
    return {
      imageUrl: process.env.VUE_APP_IMAGE_URL,
      file: null,
      loading: false
    }
  },
  methods: {
    async addFile (event) {
      const file = event.target.files[0]
      this.file = file
      if (confirm(`Are you sure you wish to add ${file.name} as the new logo for ${this.merchant.name}?`)) {
        await this.submitFile()
        this.file = null
      } else {
        this.file = null
      }
    },

    async submitFile () {
      this.loading = true
      try {
        const response = await this.getS3SecuredUrl()
        if (response) {
          const {url} = response.data
          await this.uploadImageToS3Bucket(url, this.file)
          await this.addImageToDataBase(url)
        } else {
          console.error('Logo failed to upload')
        }
      } finally {
        this.loading = false
      }
    },

    async removeLogo () {
      if (!confirm(`Are you sure you wish to remove the logo for ${this.merchant.name}?`)) {
        return
      }
      this.loading = true
      try {
        await this.removeImageFromDatabase()
      } catch (err) {
        console.error('Logo failed to remove', err)
      } finally {
        this.loading = false
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/manage/MerchantImageManagement.vue